import { gql, TypedDocumentNode } from '@common/hooks';
import {
  UpdateOrganizationOnDemandSettingsMutationCgResponse,
  UpdateOrganizationOnDemandSettingsMutationVariables,
} from '@common/graphql';

export const UpdateOnDemandSettings: TypedDocumentNode<
  UpdateOrganizationOnDemandSettingsMutationCgResponse,
  UpdateOrganizationOnDemandSettingsMutationVariables
> = gql`
  mutation UpdateOrganizationOnDemandSettings(
    $input: UpdateOrganizationOnDemandSettingsInput!
  ) {
    updateOrganizationOnDemandSettings(input: $input) {
      onDemandSetting {
        allowListsEditWithSync
      }
    }
  }
`;
